const palette = {
  redToyota: 'rgb(177, 56, 52)',
  red: 'rgb(255, 0, 0)',
};

export default palette;
